import { Box, Typography, Card, Grid } from "@mui/material";
import { cloudinaryFull } from '../../utils/formatCloudinary';
import { cardStyle } from '../../components/dashboard/transitions/TransitionStyles'

export default function AccessDenied() {

  return <Grid item>
    <Card sx={{ ...cardStyle, position: 'relative', py: 3, px: { xs: 4, sm: 8 } }}>
      <Box
        component="img"
        alt="attachment"
        src={
            cloudinaryFull(
              'https://res.cloudinary.com/agoraserv/image/upload/v1768844061/Website%20Images/Access_DeniedArtboard_1_2x_sojqad.png'
            )
        }
        sx={{ maxHeight: '50%', maxWidth: '50%', objectFit: 'contain', display: 'block', margin: 'auto' }}
      />
      <Typography variant="h3" color="secondary" sx={{ textAlign: 'center' }}>
        Access to this page is restricted
      </Typography>
    </Card>
  </Grid>
}